import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ClientSessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/support/SupportAccessBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionChecker"] */ "/app/components/VersionChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailNotificationProvider"] */ "/app/contexts/EmailNotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationProvider"] */ "/app/contexts/OrganizationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignalFeedProvider"] */ "/app/contexts/SignalFeedContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
